import React from 'react';
import { ConfirmationDelete } from 'components/Dialogs';

const MESSAGE = '';
const DeleteOPMCalculatorDialog = () => (
  <ConfirmationDelete itemName="OPM" customMessage={MESSAGE} />
);

export default DeleteOPMCalculatorDialog;
